import { Identifiable } from '@sr/dto';
import { useCallback, useEffect, useState } from 'react';

export interface IRemoteItem<T> {
  item: T;
  isLoading: boolean;
  error: string;
}

type RemoteItemConfig<TItem extends Identifiable, TUpdateItem = void> = {
  fetchHandler?: () => Promise<TItem>;
  updateHandler?: (itemData: TUpdateItem) => Promise<TItem>;
}

export const useRemoteItem =
  <TItem extends Identifiable, TUpdateItem = void>(config: RemoteItemConfig<TItem, TUpdateItem>) => {
    const { fetchHandler, updateHandler } = config;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [item, setItem] = useState<TItem | null>(null);

    const refreshItem = useCallback(async () => {
      if (!fetchHandler) return;

      setLoading(true);
      setError('');
      try {
        setItem(await fetchHandler());
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
        throw e;
      } finally {
        setLoading(false);
      }
    }, [fetchHandler]);

    useEffect(() => {
      refreshItem().catch(() => undefined);
    }, [refreshItem]);

    // const updateItem = updateHandler
    //   ? (async (data: TUpdateItem) => {
    //     const response = await updateHandler(data);
    //     setItem(response);
    //   })
    //   : async () => {
    //     throw new Error('Update handler is not specified');
    //   };

    const updateItem = updateHandler
      ? async (data: TUpdateItem) => {
        const response = await updateHandler(data);
        setItem(response);
        await refreshItem();
      }
      : async () => {
        throw new Error('Update handler is not specified');
      };

    return {
      item,
      loading,
      error,
      updateItem,
      refreshItem
    };
  };

